<template>
  <div class="cmn-userform-view-container">
    <SubsysView v-if="SubsysGUID" @onMount="OnMount" ref="SubSysView" />
    <SysView v-else @onMount="OnMount" ref="SysView" />
  </div>
</template>

<script>
import SubsysView from "./SubsysView.vue";
import SysView from "./SysView.vue";

export default {
  name: "UserFormView",
  inject: ["userForm"],
  components: { SubsysView, SysView },
  computed: {
    CurUserForm() {
      // return CmnMis.CurUserForm;
      return this.userForm;
    },
    SubsysGUID() {
      return this.CurUserForm.SubsysGUID;
    },
  },
  methods: {
    OnMount() {
      this.$emit("onMount", this.UserForm);
    },

    LoadUserFormView() {
      // this.$refs.ExtendUserForm?.LoadUserFormView();
      this.$refs.SubSysView?.LoadUserFormView();
      this.$refs.SysView?.LoadUserFormView();
    },
  },
};
</script>

<style lang="less" scoped></style>
